import * as React from "react";
import { PropsWithChildren, useRef } from "react";
import { ChevronUpIcon } from "affinityIcons";
import { styled } from "styled-components";

import { Illustration } from "./components/image";
import { Note } from "./components/note";
import { Section } from "./components/section";
import { Toc, TocProvider } from "./components/toc";

const DocContainer = styled.div`
  gap: 2rem;
  display: flex;
  flex-direction: row-reverse;
`;

const TocContainer = styled.div`
  min-width: 200px;
  flex: 1;
`;

const ContentContainer = styled.div`
  flex: auto;
  max-width: 770px;
  min-width: 510px;
`;

const Spacer = styled.div`
  min-width: 200px;
  flex: 1;
  ${({ theme }) => theme.breakpoints.down("xl")} {
    display: none;
  }
`;

export const anchorKey = (title: string): string => title.replace(/\W/g, "_").toLocaleLowerCase();

const ToTopWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 4rem;
`;
const ToTop = styled.a`
  cursor: pointer;
  background: ${(props) => props.theme.colours.grey[400]};
  color: ${(props) => props.theme.colours.white};
  border-radius: 3.5rem;
  display: flex;
  width: 3.5rem;
  height: 3.5rem;
  font-size: 1.8rem;
  justify-content: center;
  align-items: center;
  transition: all 300ms ease-in-out;
  right: 3.5rem;
  position: absolute;

  &:hover {
    background: ${(props) => props.theme.colours.blue[700]};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${(props) => props.theme.colours.focus};
  }
`;

export const Doc: React.FC<PropsWithChildren> & {
  Section: typeof Section;
  Illustration: typeof Illustration;
  Note: typeof Note;
} = ({ children }) => {
  const docRef = useRef<HTMLDivElement>(null);
  return (
    <>
      <DocContainer>
        <TocProvider docRef={docRef}>
          <TocContainer>
            <Toc />
          </TocContainer>
          <ContentContainer ref={docRef}>{children}</ContentContainer>
        </TocProvider>
        <Spacer>&nbsp;</Spacer>
      </DocContainer>
      <ToTopWrap>
        <ToTop href="#">
          <ChevronUpIcon />
        </ToTop>
      </ToTopWrap>
    </>
  );
};

Doc.Section = Section;
Doc.Illustration = Illustration;
Doc.Note = Note;
